<template>
  <div id="app">
    <!-- 顶部 banner-->
    <top-banner v-if="iframe==false"></top-banner>
    <!-- 侧边框按钮 -->
    <slide-btn v-if="iframe==false"></slide-btn>

    <router-view  @getIframeVal="showIframeVal"/>
    <!-- 底部-->
    <footer-bar v-if="iframe==false"></footer-bar>
  </div>
</template>

<script>
import TopBanner from 'components/TopBanner/TopBanner.vue'
import footerBar from 'components/footerBar/footerBar.vue'
import SlideBtn from 'components/SlideBtn/SlideBtn.vue'

export default {

  components: {
    'top-banner': TopBanner,
    'footer-bar': footerBar,
    'slide-btn': SlideBtn
  },
  data () {
    return {
      iframe: true
    }
  },
  // mounted () {
  //  this.iframe = false
  // },
  methods: {
    showIframeVal (val) { // methods方法  val即为子组件传过来的值
      console.log('showIframeVal:' + val)
      this.iframe = val
    }
  }
}
</script>

<style>
  @import './assets/css/base.css';
  @import './assets/css/animate.min.css';
  @import './assets/css/owl.carousel.css';
  @import './assets/css/style.css';
  @import './assets/css/responsive.css';
  #app {
   // width: 100%;
   // height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue